<template>
  <div class="mountain-section lifts">
    <div class="mountain-area" v-for="(area, index) in liftMountainAreas">
      <template>
        <h1 class="ttu">{{ $t(area.Name) }}</h1>
        <div class="lift-counts">
          <strong>{{ openLifts(area.Lifts) }}</strong>/{{ totalLifts(area.Lifts) }}
          {{ $t('OPEN') }}
        </div>
      </template>

      <transition-group class="flex-grid flex-grid--thirds flex-grid--halfs-small-laptop" name="fade" mode="out-in" tag="div">
        <Lift v-for="(lift, index) in area.Lifts" :index="index" :lift="lift" :key="lift.Name"></Lift>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Lift from '@/components/MountainAreas/Lift.vue';

export default {
  name: 'Lifts',
  components: {
    Lift,
  },
  data() {
    return {
    };
  },
  computed: {
    liftMountainAreas() {
      if (this.mtnAreaNavSections.indexOf('lifts') < 0) {
        // Fake it like a bawse.
        return [{
          Name: 'All Lifts',
          Lifts: this.lifts,
        }];
      }

      return this.currentActiveMountainArea
        ? [this.currentActiveMountainArea]
        : this.mountainAreas;
    },
    ...mapState(['lifts', 'mountainAreas', 'mtnAreaNavSections']),
    ...mapGetters(['openStatuses', 'currentActiveMountainArea',
      'openStatuses']),
  },
  methods: {
    openLifts(lifts) {
      const open_lifts = 0;

      return lifts.filter(lift => lift.ExcludeInTotal !== 'true' && this.openStatuses.indexOf(lift.StatusEnglish) >= 0).length;
    },
    totalLifts(lifts) {
      return lifts.filter(lift => lift.ExcludeInTotal !== 'true').length;
    },
  },
};
</script>

<style lang="scss" scoped>
  #dashboard {
    .mountain-section {
      h1 {
        color: $medium-gray;
        display: inline-block;
        font-family: $headline-font-regular;
        font-size: 26px;
        font-weight: 500;
        letter-spacing: 0.5px;
        line-height: 1.2;
        margin: 10px 10px 20px 0;
        max-width: 55%;
        @media (min-width: $tablet) {
          max-width: auto;
        }
        @media (min-width: $small-phone) {
          max-width: 65%;
        }
      }
      .lift-counts {
        color: $dark-gray;
        display: inline-block;
        float: right;
        font-family: $base-font-regular;
        font-size: 20px;
        line-height: 1.2;
        strong {
          font-family: $base-font-bold;
          font-weight: $headline-font-weight;
        }
        @media (min-width: $tablet) {
          float: none;
        }
      }
    }
    @media (max-width: $tablet) {
      .flex-grid {
        display: block;
        width: 100%;
      }
    }
  }
</style>

<i18n locale="fr-ca">
{
  "All Lifts": "Tous",
  "OPEN": "OUVERTS"
}
</i18n>
